import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M16.01 11H4V13H16.01V16L20 12L16.01 8V11Z" />,
  'ArrowRightAlt',
)
